exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".ZamRNvsHVMIc8BL8ITwRs{color:#757575}\n", ""]);

// Exports
exports.locals = {
	"CueIcon": "ZamRNvsHVMIc8BL8ITwRs"
};